import type { FaireProductEntity } from "../../entity_types/product";

export const p_4y4jh6jdvs: FaireProductEntity = {
  token: "p_4y4jh6jdvs",
  type: "product",
  name: "ALWAYS PROTECTED HAMSA EYE EVIL EYE SET, BJN 01261",
  brandToken: "b_gk6kg6d4dw",
  brandName: "JOIA ACCESSORIES",
  imageUrl:
    "https://cdn.faire.com/fastly/f31a8666b8b389b5bde5782170021387f5cfd8ae27ad81b240e349a6146c1a90.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa9400e53168380d015b880dd58fc5379bf58293341868fe9d1ee40fdf6f6946.jpeg",
    "https://cdn.faire.com/fastly/40f0e042feb666781d108078d5519e66439cdedc13b1f085d159f11b39fb1caf.jpeg",
    "https://cdn.faire.com/fastly/977f577b0b89d99c5e910b11ed2263228531a2703843ae06f28d03d1d61ce9a3.jpeg",
    "https://cdn.faire.com/fastly/2c25fd5c7b46de5beeecea00490accc174dee81a4db82390c21ea56912387466.jpeg",
    "https://cdn.faire.com/fastly/12aaf4d27f6cd55312d59121289d3374b02f9ae7330dff7802c361d65c964433.jpeg",
    "https://cdn.faire.com/fastly/f37f5da323ee923da6947e6863eb1b6dbe581605f45419669f9a6c78d0d4bc78.jpeg",
  ],
  priceDollars: 12.12,
  description:
    "ALWAYS PROTECTED HAMSA EYE EVIL EYE SET ALWAYS PROTECTED HAMSA EYE EVIL EYE SET",
  tags: [],
  msrpDollars: 24.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:57.963Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
